import styled from '@emotion/styled';
import FixedBottomBar from '@portalterreno/react-ui-core/FixedBottomBar';

const StyledFixedBottomBar = styled(FixedBottomBar)(
  {
    display: 'flex',
    justifyContent: 'center',
    zIndex: 99
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.colors.midnightBlue,
    color: theme.palette.colors.white
  })
);

export default StyledFixedBottomBar;
